import(/* webpackMode: "eager" */ "/app/src/app/all-leaders/[slug]/page.tsx");
